import React, { useState } from 'react';
import css from './editable-text.module.scss';
import { useInputWidth } from './hooks/useInputWidth';
import { useFocusOnCondition } from '../../../hooks/useFocusOnCondition';
import { TagGroupType } from '../../../entities/template/private-template-tag-group/model/types';

interface EditableTextProps {
	id: string;
	editableGroup: string | null;
	name: string;
	newGroupName: string;
	handleNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	updateGroupName: () => void;
	handleInputKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
	handleNameKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	handleNameClick: (e: React.MouseEvent) => void;
	paddingRight?: number,
}

export const EditableText = ({
	id,
	editableGroup,
	name,
	newGroupName,
	handleNameChange,
	updateGroupName,
	handleInputKeyDown,
	handleNameKeyDown,
	handleNameClick,
	paddingRight,
}: EditableTextProps) => {
	const [isHovered, setIsHovered] = useState(false);
	const { inputRef, sizerRef, inputWidth } = useInputWidth(newGroupName, editableGroup, id, paddingRight);

	const isSpecialGroup = Object.values(TagGroupType).includes(id as TagGroupType);

	const handleGroupClick = (e: React.MouseEvent) => {
		if (!isSpecialGroup) {
			handleNameClick(e);
		}
	};

	useFocusOnCondition(inputRef, editableGroup === id, {
		setCursorToEnd: true,
	});

	return (
		<div
			className={css.text}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			{editableGroup === id ? (
				<>
					<input
						ref={inputRef}
						type="text"
						value={newGroupName}
						onChange={handleNameChange}
						onBlur={(e) => {
							e.stopPropagation();
							updateGroupName();
						}}
						onKeyDown={handleInputKeyDown}
						onClick={(e) => e.stopPropagation()}
						className={`${css.titleActive} ${isHovered ? css.hovered : ''}`}
						style={{
							width: inputWidth ? `${inputWidth}px` : 'auto',
							visibility: editableGroup === id ? 'visible' : 'hidden',
						}}
					/>
					<span ref={sizerRef} className={css.sizer}>
						{newGroupName || ' '}
					</span>
				</>
			) : (
				<div
					role="button"
					tabIndex={0}
					onKeyDown={handleNameKeyDown}
					onClick={handleGroupClick}
					className={css.hover_container}
					style={isSpecialGroup ? { pointerEvents: 'none' } : {}}
				>
					{name}
				</div>
			)}
		</div>
	);
};
